import { render } from "./TabBtn.vue?vue&type=template&id=860a3f4c"
import script from "./TabBtn.vue?vue&type=script&lang=js"
export * from "./TabBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__